// Plugin de i18n para Worktime Client
// Migrado de Vue I18n v8 (Vue 2) a v10 (Vue 3)

import type { I18nOptions } from 'vue-i18n'
import { createI18n } from 'vue-i18n'

// Importar mensajes directamente (Vite usa import.meta.glob en lugar de require.context)
import en from '../locale/en.json'
import es from '../locale/es.json'
import it from '../locale/it.json'
import ro from '../locale/ro.json'

/**
 * Obtiene el locale del navegador
 */
function getBrowserLocale(): string {
  const navigatorLocale =
    navigator.languages !== undefined
      ? navigator.languages[0]
      : navigator.language

  if (!navigatorLocale) {
    return 'en'
  }

  // Extraer solo el código del idioma (ej: 'es-ES' -> 'es')
  const locale = navigatorLocale.trim().split(/[-_]/)[0]
  
  return locale
}

/**
 * Obtiene el locale inicial de la aplicación
 */
function getStartingLocale(): string {
  const browserLocale = getBrowserLocale()
  const supportedLocales = ['es', 'en', 'ro', 'it']
  
  if (supportedLocales.includes(browserLocale)) {
    return browserLocale
  }
  
  return import.meta.env.VITE_I18N_LOCALE || 'en'
}

/**
 * Configuración de i18n
 */
const i18nConfig: I18nOptions = {
  legacy: false, // Usar Composition API
  locale: getStartingLocale(),
  fallbackLocale: 'en',
  messages: {
    es,
    en,
    it,
    ro,
  },
  globalInjection: true, // Inyecta $t globalmente
  missingWarn: false, // No advertir sobre traducciones faltantes en desarrollo
  fallbackWarn: false,
}

/**
 * Instancia de i18n
 */
export const i18n = createI18n(i18nConfig)

/**
 * Helper para cambiar el locale
 */
export function setLocale(locale: string): void {
  const globalI18n = i18n.global as any
  if (globalI18n.availableLocales.includes(locale)) {
    globalI18n.locale.value = locale
  }
}

/**
 * Helper para obtener el locale actual
 */
export function getCurrentLocale(): string {
  const globalI18n = i18n.global as any
  return globalI18n.locale.value as string
}
